export default __webpack_public_path__ + "static/FuturaBT-Medium-a5fbfcfe03578d8fb9344a6b2a46b67d.woff2";